import { defineComponent as _defineComponent } from 'vue'

const __default__ = { name: 'BookingRangeBanner' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  label: { type: String, required: true }
},
  emits: ["switch-to-day"],
  setup(__props, { emit }: { emit: ({ (e: 'switch-to-day'): void }), expose: any, slots: any, attrs: any }) {

// Shared multi-day banner for the booking views (OTC-166)



return { __sfc: true,emit }
}

})